import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Globals } from "./constants";
import { getCDNUrl, getUnsubPath } from "./HelperFunctions";
import Axios from "axios";
import ConfirmUnsub from "./newLoginFlow/confirmUnsub";
import "./css/cricwick.css";
import 'react-dropdown/style.css';

import logo from "./images/logo2.png";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unsubBtnTxt: "Unsubscribe",
      unsubBtnDisabled: false,
      unsubPath: "",
      unsubPopUp: false,
      editPopUp: false,
      userData: null,
      openUserProfile: false,
      isLoading: true
    };

    this.getUserIcon = this.getUserIcon.bind(this);
    this.getUnsubButton = this.getUnsubButton.bind(this);
    this.unsub = this.unsub.bind(this);
    this.userProfile = this.userProfile.bind(this);

    this.countryCode = localStorage.getItem('countryCode') ? localStorage.getItem('countryCode') : "pk";

    let red = "#FF0000";
  }

  componentDidMount() {
    this.setGoogleAnalyticsId(this.props.userTelco);
    console.clear();
    console.log("current page: ", this.props.currentPage);
    
  }

  componentDidUpdate (prevProps, prevState) {
    console.log("prev: ", prevProps.currentPage);
    console.log("current props: ", this.props.currentPage);
  }

  authHeader() {
    let token;
    let msisdn;
    let user = JSON.parse(localStorage.getItem("user"))
    token = user.xAccessToken;
    msisdn = user.phone;

    return {
      "x-access-token": token,
      msisdn: msisdn,
    }
  }

  getUserProfile = async () => {
    if(this.props.userLoggedIn) {
    const response = await Axios.get(`${Globals.UserManagment}api/v1/users/get-user-profile`, {
      headers: this.authHeader(),
    });
    if (response.data.status === 1 && response.data.data) {
      let userData = response.data.data;
      this.setState({
        userData: userData,
      })
    }
  } else {
    this.props.history.push("/login")
  }
    //return userData;
  } 

  // By Tariq for goole Analatics

  setGoogleAnalyticsId = (telco) => {
    if (telco === "mobilink") {
      window.ga("create", "UA-88965851-3", "auto");
      return;
    } else if (telco === "zain") {
      window.ga("create", "UA-88034149-1", "auto");
      return;
    } else if (telco === "ufone") {
      window.ga("create", "UA-119615143-1", "auto");
      return;
    } else if (telco === "zong") {
      window.ga("create", "UA-141301155-1", "auto");
      return;
    } else {
      window.ga("create", "UA-88034149-3", "auto");
      return;
    }
  };

  setPageUrlForGoogleAL = (url) => {
    let urlPrefix =
      this.props.userTelco === "" ? "cricwick" : this.props.userTelco;
    window.ga("set", "page", `${urlPrefix}` + url);
    window.ga("send", "pageview", `${urlPrefix}` + url);
  };

  // By Tariq for goole Analatics
  handleGoogleAnalytics = (location) => {
    if (window.ga) {
      if (location.pathname === "/login") {
        let url = location.pathname;
        this.setPageUrlForGoogleAL(url);
        return;
      }

      //if (location.search.length == 10) {
      // here we are using search Params, so we concat it to the url string
      let url = location.pathname + location.search;
      this.setPageUrlForGoogleAL(url);
      return;

      //   }
    }
  };

  //===========================

  getTelcoLogo() {
    return Globals.telcoLogo ? (
      <span className="telco-logo ml-3 ml-lg-4">
        <img src={Globals.telcoLogo} alt="" />
      </span>
    ) : (
      ""
    );
  }

  downloadApp = () => {
    let countryCode = localStorage.getItem("countryCode");
    let appUrl =
      Globals.appUrl[countryCode && countryCode.length ? countryCode : "pk"];
    let sUsrAg = navigator.userAgent,
      win,
      url;
    if (sUsrAg.indexOf("Android") > -1) {
      // url = this.state.appPath;
      url = appUrl["android"];
      window.open(url);
    } else {
      // url = this.state.appPathIos;
      url = appUrl["ios"];
      win = window.open(url, "_blank");
      win.focus();
    }
  };

  getDownloadButton = () => {
    return Globals.telco !== "mobilink" ? (
      <div className={`d-lg-none`}>
        <button
          className="submitHollow1 border-0 btn rounded-0 p-3 text-uppercase font-weight-bold mr-4"
          onClick={this.downloadApp}
          disabled={this.state.btnDisbaled}
        >
          {`Download App`}
        </button>
      </div>
    ) : null;
  };

  userProfile() {
      this.getUserProfile();
    //if (this.props.userLoggedIn) {
      this.props.history.push(`/user-profile`)
    //} else {
      //this.props.history.push(`/login`)
    //}
  }

  getUserIcon() {
    let userlogin = localStorage.getItem("user_logged_in");

    if (userlogin) {
      return (
        <div className=" form-inline ml-auto p0 order-1 order-lg-2">
          <div className={`d-flex align-items-center dropdown`}>
            {this.getDownloadButton()}
            <a
              href="javascript:;"
              className="user"
              data-toggle="dropdown"
              //data-target="#welcomeModal"
            >
              <img src={getCDNUrl("/images/profile_icon.png")} alt="" />
            </a>
            <ul class="dropdown-menu p-3" role="menu" aria-labelledby="menu1">
            <li className="mt-1 dropdown-line" style={{cursor: "pointer"}} role="presentation"><p onClick={this.props.userLoggedIn ? this.userProfile : this.props.history.push('/login')} 
              >User Profile</p></li> 
              <li className="mt-2 dropdown-line" style={{cursor: "pointer"}} role="presentation"><p role="menuitem" tabindex="-1" onClick={() =>
                                this.setState({
                                  unsubPopUp: true,
                                })
                              }>Change Subscription</p></li>
              <li className="mt-2 dropdown-line" style={{cursor: "pointer"}} role="presentation">{this.getUnsubBtn()}</li>
              <li className="mt-2" role="presentation" style={{cursor: "pointer"}}><p role="menuitem" tabindex="-1" onClick={this.logout}>Logout</p></li>   
                
            </ul>
            {this.getTelcoLogo()}
          </div>
        </div>
      );
    } else {
      return (
        <div className="form-inline ml-auto p0 order-1 order-lg-2">
          {Globals.telco === "zong" ? (
            <span className="service">Zong Cricket</span>
          ) : (
            ""
          )}
          <div className={`d-flex align-items-center`}>
            {this.getDownloadButton()}
            <Link to="/login" className="user ">
              <img src={getCDNUrl("/images/profile_icon.png")} alt="" />
            </Link>
          </div>

          {this.getTelcoLogo()}
        </div>
      );
    }
  }

  logout(e) {
    localStorage.removeItem("user");
    localStorage.removeItem("user_logged_in");
    localStorage.removeItem("isSocialProfileAttached");
    localStorage.removeItem("countryCode");
    window.location.href = "/";
  }

  getUnsubButton() {
    if (this.props.userLoggedIn) {
      let unsubPathObj = getUnsubPath(JSON.parse(localStorage.getItem("user")));
      if (unsubPathObj.status === 1 && unsubPathObj.path) {
        return (
          <div className="button">
            <button
              type="button"
              className="btn btn-lg btn-primary allow-login mt-2"
              style={{ position: "relative", zIndex: "1" }}
              unsubpath={unsubPathObj.path}
              onClick={this.unsub}
              disabled={this.state.unsubBtnDisabled}
            >
                {this.state.unsubBtnTxt}
            </button>
          </div>
        );
      }
    }
  }

  getUnsubBtn() {
    if (this.props.userLoggedIn) {
      let unsubPathObj = getUnsubPath(JSON.parse(localStorage.getItem("user")));
      if (unsubPathObj.status === 1 && unsubPathObj.path) {
        return (
          <div className="button">
            {/*<button
              type="button"
              className="btn btn-lg btn-primary allow-login mt-2"
              style={{ position: "relative", zIndex: "1" }}
              unsubpath={unsubPathObj.path}
              onClick={this.unsub}
              disabled={this.state.unsubBtnDisabled}
            >*/}
            <p
              role="menuitem" 
              tabindex="-1"
              unsubpath={unsubPathObj.path}
              onClick={this.unsub}
              disabled={this.state.unsubBtnDisabled}>
                {this.state.unsubBtnTxt}
            </p>
            {/*</button>*/}
          </div>
        );
      }
    }
  }


  async unsub(e) {
  
    let url = e.target.getAttribute("unsubpath");
    this.setState(
      { unsubBtnTxt: "Please wait ...", unsubBtnDisabled: true },
      async () => {
        let resp = {},
          user = JSON.parse(localStorage.getItem("user"));
        try {
           ;
          resp = await Axios.get(url,
            {
              headers: {
                "auth-token": user.authToken
              },
            });
          resp = await Axios.get(
            `${Globals.UserManagment}api/v1/users/unsub-user`,
            {
              headers: {
                "x-access-token": user.xAccessToken,
                msisdn: user.phone,
              },
            }
          );
        } catch {
          console.log("tahir unsub failed");
        }

        this.logout();
      }
    );
  }

  render() {
      this.handleGoogleAnalytics(this.props.location);
      let red = "#FF0000";

    return (
      <>
         <nav
         id="main-nav"
         className="navbar navbar-expand-lg navbar-light py-0 shadow-md mb-2"
       >
        
         <div className="container">
           <button
             className="navbar-toggler p-0 collapsed"
             type="button"
             data-toggle="collapse"
             data-target="#navbarContent"
           >
             <i className="fa fa-bars" />
           </button>
           <Link
             to="/"
             className="navbar-brand mr-auto pl-3 py-1 p-0 pb-lg-2 pt-lg-1 pl-lg-0 mr-lg-5 order-0"
           >
             <img className="logo" src={logo} alt="" />
           </Link>
           
           <div
             className="collapse navbar-collapse m-0 p-0 order-2 order-lg-1 text-center"
             id="navbarContent"
           >
             <div className="divider" />

             <ul className="navbar-nav ml-lg-4 ml-0">
               <li
                 id="series"
                 className={
                   this.props.currentPage === "/live-cricket-score" ||
                   this.props.currentPage === "/series"
                     ? "active nav-item px-3"
                     : "nav-item px-3"
                 }
               >
                 <Link className="nav-link" to="/live-cricket-score/live">
                   Series{" "}
                   <i
                     className="fa fa-angle-right d-lg-none float-right"
                     aria-hidden="true"
                   />
                 </Link>
               </li>
               <li
                 id="videos"
                 className={
                   this.props.currentPage === "/videos" ||
                   this.props.currentPage === "/video"
                     ? "active nav-item px-3"
                     : "nav-item px-3"
                 }
               >
                 <Link className="nav-link" to="/videos">
                   Videos{" "}
                   <i
                     className="fa fa-angle-right d-lg-none float-right"
                     aria-hidden="true"
                   />
                 </Link>
               </li>
               
               <li
                 id="updates"
                 className={
                   this.props.currentPage === "/updates/news"
                     ? "active nav-item px-3"
                     : "nav-item px-3"
                 }
               >
                 <Link className="nav-link" to="/updates/news">
                   News{" "}
                   <i
                     className="fa fa-angle-right d-lg-none float-right"
                     aria-hidden="true"
                   />
                 </Link>
               </li>
               <li
                 id="articles"
                 className={
                   this.props.currentPage === "/updates/articles"
                     ? "active nav-item px-3"
                     : "nav-item px-3"
                 }
               >
                 <Link className="nav-link" to="/updates/articles">
                   Articles{" "}
                   <i
                     className="fa fa-angle-right d-lg-none float-right"
                     aria-hidden="true"
                   />
                 </Link>
               </li>
               <li
                 id="rankings"
                 className={
                   this.props.currentPage === "/rankings"
                     ? "active nav-item px-3"
                     : "nav-item px-3"
                 }
               >
                 <Link className="nav-link" to="/rankings/test">
                   Rankings{" "}
                   <i
                     className="fa fa-angle-right d-lg-none float-right"
                     aria-hidden="true"
                   />
                 </Link>
               </li>
             </ul>
           </div>{" "}
         </div>
        
       </nav> 
     </> 
    );
  }
}

export default withRouter(Nav);
